var map = {
  "./da.json": [
    "19552",
    [
      9913
    ]
  ],
  "./fi.json": [
    "68834",
    [
      67903
    ]
  ],
  "./sv.json": [
    "89362",
    [
      15151
    ]
  ],
  "./ja.json": [
    "40102",
    [
      33323
    ]
  ],
  "./lt.json": [
    "55911",
    [
      45740
    ]
  ],
  "./sl.json": [
    "41608",
    [
      85553
    ]
  ],
  "./fr.json": [
    "61627",
    [
      65928
    ]
  ],
  "./es.json": [
    "1967",
    [
      55300
    ]
  ],
  "./no.json": [
    "81668",
    [
      39397
    ]
  ],
  "./cs.json": [
    "59097",
    [
      33442
    ]
  ],
  "./en.json": [
    "88360",
    [
      4721
    ]
  ],
  "./description/en.json": [
    "24791",
    [
      63388
    ]
  ],
  "./pl.json": [
    "62531",
    [
      90848
    ]
  ],
  "./hu.json": [
    "28992",
    [
      17817
    ]
  ],
  "./nl.json": [
    "50129",
    [
      26538
    ]
  ],
  "./de.json": [
    "4092",
    [
      10637
    ]
  ],
  "./pt.json": [
    "97867",
    [
      30584
    ]
  ],
  "./it.json": [
    "9158",
    [
      44203
    ]
  ],
  "./et.json": [
    "40562",
    [
      18095
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 41514;
module.exports = __rspack_async_context;
